unit SystemTFNSubAccountsSetup;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.ExtCtrls, WEBLib.DBCtrls, Data.DB, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Client;

type
  TfrmTFNSubAccountsSetup = class(TForm)
    WebPanel1: TPanel;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    WebPanel2: TPanel;
    WebPanel3: TPanel;
    WebDBEdit1: TDBEdit;
    edtSubContractor: TDBEdit;
    WebButton1: TButton;
    WebButton2: TButton;
    btnSearchSubs: TButton;
    wcTFNSubAccounts: TXDataWebClient;
    wdsTFNSubAccounts: TXDataWebDataSet;
    wdsTFNSubAccountsApiServerNo: TIntegerField;
    wdsTFNSubAccountsSubContractNo: TStringField;
    wdsTFNSubAccountsApiAccountNo: TStringField;
    wdsTFNSubAccountsLastRunDate: TDateField;
    wdsTFNSubAccountsSubsRegNo: TStringField;
    wdsTFNSubAccountsCRName: TStringField;
    dsTFNSubAccounts: TDataSource;
    lblOut: TLabel;
    procedure WebButton1Click(Sender: TObject);
    procedure btnSearchSubsClick(Sender: TObject);
    procedure WebButton2Click(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
  private
    { Private declarations }


    procedure LoadTFNSubAccounts;
  public
    { Public declarations }
    sCompany, sSubcontractorno : String;
    iSystem, iState, iApiserverno : Integer;
  protected procedure LoadDFMValues; override; end;

var
  frmTFNSubAccountsSetup: TfrmTFNSubAccountsSetup;

implementation

{$R *.dfm}
  uses
    stfmssystem.connection , share.system.classes , share.common,
    search.subs;

procedure TfrmTFNSubAccountsSetup.LoadTFNSubAccounts;
  procedure OnResultTFNSubAccounts(Response : TXDataClientResponse);
    begin
      wdsTFNSubAccounts.Close;
      wdsTFNSubAccounts.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsTFNSubAccounts.Open;

      lblOut.Caption := sSubcontractorno;

      console.log(GetJsonFromDataSet(wdsTFNSubAccounts));

      if iState = 2 then
        Begin
          wdsTFNSubAccounts.Edit;
        End;

    end;
begin
  wcTFNSubAccounts.RawInvoke('IstfmsSystemService.Get_TFNSubAccountsS1_View',[0,1,sSubcontractorno],@OnResultTFNSubAccounts);
end;

procedure TfrmTFNSubAccountsSetup.WebButton1Click(Sender: TObject);
  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      wdsTFNSubAccounts.Cancel;
      Close;
    end;
  procedure OnError(Error: TXDataClientError);
    begin
      ShowMessage(Error.ErrorMessage);
      Close;
    end;
begin

    wdsTFNSubAccounts.FieldByName('ApiServerNo').AsInteger := 1;

    case iState of
      1 : Begin
            console.log(GetJsonFromDataSet(wdsTFNSubAccounts));
            wcTFNSubAccounts.RawInvoke('IstfmsSystemService.Put_TFNSubAccountsS1_Insert',[GetJsonFromDataSet(wdsTFNSubAccounts)],@OnSuccess, @OnError);
          End;
      2 : Begin

            wcTFNSubAccounts.RawInvoke('IstfmsSystemService.Put_TFNSubAccountsS1_Edit',[sSubcontractorno,GetJsonFromDataSet(wdsTFNSubAccounts)],@OnSuccess, @OnError);
          End;
    end;
end;

procedure TfrmTFNSubAccountsSetup.WebButton2Click(Sender: TObject);
begin
  Close;
end;

procedure TfrmTFNSubAccountsSetup.WebFormShow(Sender: TObject);
begin

  if iState = 1 then
    Begin
      wdsTFNSubAccounts.Open;
      wdsTFNSubAccounts.Insert;
    End;

  if iState = 2 then
    Begin
       LoadTFNSubAccounts;
    End;

end;

procedure TfrmTFNSubAccountsSetup.btnSearchSubsClick(Sender: TObject);
  var
    LFrm : TfrmSearchSubs;

  procedure AfterShowModal(AValue: TModalResult);
  begin
    with LFrm do
      begin
        if sCode <> '' then
          begin
            edtSubContractor.Text := sCode;
            sCompany := sCode;
            wdsTFNSubAccounts.FieldByName('SubContractNo').AsString := sCode;

            console.log(GetJsonFromDataSet(wdsTFNSubAccounts));
          end
        else
          begin
            edtSubContractor.Text := '';
            sCompany := '';
            wdsTFNSubAccounts.FieldByName('SubContractNo').AsString := '';
          end;
      end;
  end;

  procedure AfterCreate(AForm : TObject);
  begin
    with (AForm as TfrmSearchSubs) do
      begin
        bSuspended := True;
        iType := 0;
        GetData;

      end;
  end;
begin
  LFrm := TfrmSearchSubs.CreateNew( @AfterCreate );

  // LFrm als Pop-Up festlegen
  LFrm.Popup := true;

  // Transparenz definieren
  LFrm.PopupOpacity := 0.2;

  LFrm.ShowModal(@AfterShowModal);
end;

procedure TfrmTFNSubAccountsSetup.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  lblOut := TLabel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebButton2 := TButton.Create(Self);
  WebDBEdit1 := TDBEdit.Create(Self);
  edtSubContractor := TDBEdit.Create(Self);
  btnSearchSubs := TButton.Create(Self);
  wcTFNSubAccounts := TXDataWebClient.Create(Self);
  wdsTFNSubAccounts := TXDataWebDataSet.Create(Self);
  wdsTFNSubAccountsApiServerNo := TIntegerField.Create(Self);
  wdsTFNSubAccountsSubContractNo := TStringField.Create(Self);
  wdsTFNSubAccountsApiAccountNo := TStringField.Create(Self);
  wdsTFNSubAccountsLastRunDate := TDateField.Create(Self);
  wdsTFNSubAccountsSubsRegNo := TStringField.Create(Self);
  wdsTFNSubAccountsCRName := TStringField.Create(Self);
  dsTFNSubAccounts := TDataSource.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  lblOut.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  WebDBEdit1.BeforeLoadDFMValues;
  edtSubContractor.BeforeLoadDFMValues;
  btnSearchSubs.BeforeLoadDFMValues;
  wcTFNSubAccounts.BeforeLoadDFMValues;
  wdsTFNSubAccounts.BeforeLoadDFMValues;
  wdsTFNSubAccountsApiServerNo.BeforeLoadDFMValues;
  wdsTFNSubAccountsSubContractNo.BeforeLoadDFMValues;
  wdsTFNSubAccountsApiAccountNo.BeforeLoadDFMValues;
  wdsTFNSubAccountsLastRunDate.BeforeLoadDFMValues;
  wdsTFNSubAccountsSubsRegNo.BeforeLoadDFMValues;
  wdsTFNSubAccountsCRName.BeforeLoadDFMValues;
  dsTFNSubAccounts.BeforeLoadDFMValues;
  try
    Name := 'frmTFNSubAccountsSetup';
    Width := 557;
    Height := 300;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 557;
    WebPanel1.Height := 300;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebLabel1.SetParentComponent(WebPanel1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 64;
    WebLabel1.Top := 99;
    WebLabel1.Width := 85;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'Sub-Contractor:';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(WebPanel1);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 64;
    WebLabel2.Top := 147;
    WebLabel2.Width := 64;
    WebLabel2.Height := 15;
    WebLabel2.Caption := 'AccountNo:';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    lblOut.SetParentComponent(WebPanel1);
    lblOut.Name := 'lblOut';
    lblOut.Left := 416;
    lblOut.Top := 162;
    lblOut.Width := 33;
    lblOut.Height := 15;
    lblOut.Caption := 'lblOut';
    lblOut.HeightPercent := 100.000000000000000000;
    lblOut.WidthPercent := 100.000000000000000000;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 557;
    WebPanel2.Height := 60;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'TFN Sub Accounts Setup';
    WebPanel2.ChildOrder := 6;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -16;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 0;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 240;
    WebPanel3.Width := 557;
    WebPanel3.Height := 60;
    WebPanel3.Align := alBottom;
    WebPanel3.ChildOrder := 7;
    WebPanel3.TabOrder := 1;
    WebButton1.SetParentComponent(WebPanel3);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 22;
    WebButton1.Top := 18;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Save';
    WebButton1.Color := clYellowgreen;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    WebButton2.SetParentComponent(WebPanel3);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 437;
    WebButton2.Top := 18;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Cancel';
    WebButton2.Color := clRed;
    WebButton2.ChildOrder := 1;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton2, Self, 'OnClick', 'WebButton2Click');
    WebDBEdit1.SetParentComponent(WebPanel1);
    WebDBEdit1.Name := 'WebDBEdit1';
    WebDBEdit1.Left := 160;
    WebDBEdit1.Top := 144;
    WebDBEdit1.Width := 153;
    WebDBEdit1.Height := 22;
    WebDBEdit1.ChildOrder := 5;
    WebDBEdit1.HeightPercent := 100.000000000000000000;
    WebDBEdit1.WidthPercent := 100.000000000000000000;
    WebDBEdit1.DataField := 'ApiAccountNo';
    WebDBEdit1.DataSource := dsTFNSubAccounts;
    edtSubContractor.SetParentComponent(WebPanel1);
    edtSubContractor.Name := 'edtSubContractor';
    edtSubContractor.Left := 160;
    edtSubContractor.Top := 96;
    edtSubContractor.Width := 209;
    edtSubContractor.Height := 22;
    edtSubContractor.ChildOrder := 7;
    edtSubContractor.HeightPercent := 100.000000000000000000;
    edtSubContractor.WidthPercent := 100.000000000000000000;
    edtSubContractor.DataField := 'SubContractNo';
    edtSubContractor.DataSource := dsTFNSubAccounts;
    btnSearchSubs.SetParentComponent(WebPanel1);
    btnSearchSubs.Name := 'btnSearchSubs';
    btnSearchSubs.Left := 375;
    btnSearchSubs.Top := 96;
    btnSearchSubs.Width := 25;
    btnSearchSubs.Height := 22;
    btnSearchSubs.Caption := '...';
    btnSearchSubs.Color := clWhite;
    btnSearchSubs.ChildOrder := 8;
    btnSearchSubs.HeightPercent := 100.000000000000000000;
    btnSearchSubs.WidthPercent := 100.000000000000000000;
    SetEvent(btnSearchSubs, Self, 'OnClick', 'btnSearchSubsClick');
    wcTFNSubAccounts.SetParentComponent(Self);
    wcTFNSubAccounts.Name := 'wcTFNSubAccounts';
    wcTFNSubAccounts.Connection := dmData.dbConnect;
    wcTFNSubAccounts.Left := 23;
    wcTFNSubAccounts.Top := 16;
    wdsTFNSubAccounts.SetParentComponent(Self);
    wdsTFNSubAccounts.Name := 'wdsTFNSubAccounts';
    wdsTFNSubAccounts.Connection := dmData.dbConnect;
    wdsTFNSubAccounts.Left := 79;
    wdsTFNSubAccounts.Top := 16;
    wdsTFNSubAccountsApiServerNo.SetParentComponent(wdsTFNSubAccounts);
    wdsTFNSubAccountsApiServerNo.Name := 'wdsTFNSubAccountsApiServerNo';
    wdsTFNSubAccountsApiServerNo.FieldName := 'ApiServerNo';
    wdsTFNSubAccountsSubContractNo.SetParentComponent(wdsTFNSubAccounts);
    wdsTFNSubAccountsSubContractNo.Name := 'wdsTFNSubAccountsSubContractNo';
    wdsTFNSubAccountsSubContractNo.FieldName := 'SubContractNo';
    wdsTFNSubAccountsApiAccountNo.SetParentComponent(wdsTFNSubAccounts);
    wdsTFNSubAccountsApiAccountNo.Name := 'wdsTFNSubAccountsApiAccountNo';
    wdsTFNSubAccountsApiAccountNo.FieldName := 'ApiAccountNo';
    wdsTFNSubAccountsLastRunDate.SetParentComponent(wdsTFNSubAccounts);
    wdsTFNSubAccountsLastRunDate.Name := 'wdsTFNSubAccountsLastRunDate';
    wdsTFNSubAccountsLastRunDate.FieldName := 'LastRunDate';
    wdsTFNSubAccountsSubsRegNo.SetParentComponent(wdsTFNSubAccounts);
    wdsTFNSubAccountsSubsRegNo.Name := 'wdsTFNSubAccountsSubsRegNo';
    wdsTFNSubAccountsSubsRegNo.FieldName := 'SubsRegNo';
    wdsTFNSubAccountsCRName.SetParentComponent(wdsTFNSubAccounts);
    wdsTFNSubAccountsCRName.Name := 'wdsTFNSubAccountsCRName';
    wdsTFNSubAccountsCRName.FieldName := 'CRName';
    dsTFNSubAccounts.SetParentComponent(Self);
    dsTFNSubAccounts.Name := 'dsTFNSubAccounts';
    dsTFNSubAccounts.AutoEdit := False;
    dsTFNSubAccounts.DataSet := wdsTFNSubAccounts;
    dsTFNSubAccounts.Left := 137;
    dsTFNSubAccounts.Top := 16;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    lblOut.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    WebDBEdit1.AfterLoadDFMValues;
    edtSubContractor.AfterLoadDFMValues;
    btnSearchSubs.AfterLoadDFMValues;
    wcTFNSubAccounts.AfterLoadDFMValues;
    wdsTFNSubAccounts.AfterLoadDFMValues;
    wdsTFNSubAccountsApiServerNo.AfterLoadDFMValues;
    wdsTFNSubAccountsSubContractNo.AfterLoadDFMValues;
    wdsTFNSubAccountsApiAccountNo.AfterLoadDFMValues;
    wdsTFNSubAccountsLastRunDate.AfterLoadDFMValues;
    wdsTFNSubAccountsSubsRegNo.AfterLoadDFMValues;
    wdsTFNSubAccountsCRName.AfterLoadDFMValues;
    dsTFNSubAccounts.AfterLoadDFMValues;
  end;
end;

end.